import { combineEpics } from "redux-observable";
import { epicStoreBuyPackage } from "./epics/epicStoreBuyPackage";
import { epicStoreBuyPackageRequest } from "./epics/epicStoreBuyPackageRequest";
import { epicStoreCollectChestReward } from "./epics/epicStoreCollectChestReward";
export var epicStore = combineEpics(epicStoreBuyPackage, epicStoreBuyPackageRequest, epicStoreCollectChestReward);



//////////////////
// WEBPACK FOOTER
// ./src/features/store/epicStore.ts
// module id = 2415
// module chunks = 3